"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
const phaethonApi_1 = require("../../private/api-services/phaethonApi");
const authData_1 = require("../../private/ephemeral/authData");
const env_1 = require("../../conf/env");
class Search {
    /**
     *
     */
    constructor() {
        if (!authData_1.Auth.getUserToken()) {
            throw new Error("please use the Authenticator service first");
        }
        if (!authData_1.Auth.getDomainToken()) {
            throw new Error("performing search requires a domain token");
        }
        this.api = new phaethonApi_1.PhaethonApi(env_1.PHAETHON_API_KEY, authData_1.Auth.getUserToken(), authData_1.Auth.getDomainToken());
    }
    /**
     *
     * @param term
     * @returns
     */
    globalSearch(term) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.globalSearch(term);
                return response.results;
            }
            catch (e) {
                throw e;
            }
        });
    }
    /**
     *
     * @param term
     * @returns
     */
    autocomplete(term) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.autocomplete(term);
                return response.results;
            }
            catch (e) {
                throw e;
            }
        });
    }
}
exports.Search = Search;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VhcmNoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3B1YmxpYy9zZXJ2aWNlcy9zZWFyY2gudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsd0VBQXFFO0FBQ3JFLCtEQUF3RDtBQUV4RCx3Q0FBa0Q7QUFFbEQsTUFBYSxNQUFNO0lBR2pCOztPQUVHO0lBQ0g7UUFDRSxJQUFJLENBQUMsZUFBSSxDQUFDLFlBQVksRUFBRSxFQUFFO1lBQ3hCLE1BQU0sSUFBSSxLQUFLLENBQUMsNENBQTRDLENBQUMsQ0FBQztTQUMvRDtRQUVELElBQUksQ0FBQyxlQUFJLENBQUMsY0FBYyxFQUFFLEVBQUU7WUFDMUIsTUFBTSxJQUFJLEtBQUssQ0FBQywyQ0FBMkMsQ0FBQyxDQUFDO1NBQzlEO1FBRUQsSUFBSSxDQUFDLEdBQUcsR0FBRyxJQUFJLHlCQUFXLENBQU0sc0JBQWdCLEVBQUMsZUFBSSxDQUFDLFlBQVksRUFBRSxFQUFFLGVBQUksQ0FBQyxjQUFjLEVBQUUsQ0FBQyxDQUFDO0lBQy9GLENBQUM7SUFFRDs7OztPQUlHO0lBQ1UsWUFBWSxDQUFDLElBQVk7O1lBQ3BDLElBQUk7Z0JBQ0YsTUFBTSxRQUFRLEdBQUcsTUFBTSxJQUFJLENBQUMsR0FBRyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQztnQkFDbkQsT0FBUSxRQUFnQixDQUFDLE9BQU8sQ0FBQzthQUNsQztZQUFDLE9BQU8sQ0FBQyxFQUFFO2dCQUNWLE1BQU0sQ0FBQyxDQUFDO2FBQ1Q7UUFDSCxDQUFDO0tBQUE7SUFFRDs7OztPQUlHO0lBQ1csWUFBWSxDQUFDLElBQVk7O1lBQ3JDLElBQUk7Z0JBQ0YsTUFBTSxRQUFRLEdBQUcsTUFBTSxJQUFJLENBQUMsR0FBRyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQztnQkFDbkQsT0FBUSxRQUFnQixDQUFDLE9BQU8sQ0FBQzthQUNsQztZQUFDLE9BQU8sQ0FBQyxFQUFFO2dCQUNWLE1BQU0sQ0FBQyxDQUFDO2FBQ1Q7UUFDSCxDQUFDO0tBQUE7Q0FDRjtBQTdDRCx3QkE2Q0MifQ==